import { useDisclosure } from '@/hooks';
import { Button, Tooltip } from 'antd';

import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkorderForms } from '../../WorkOrderFormProvider';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import ComplementAuthorizeModal from '../ComplementAuthorizeModal';
import formatterPrice from '@/utils/number/formatterPrice';
import { useWorkOrderItems } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';

const ComplementAuthorize: React.FC = () => {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
    isAlerted,
    setIsAlert,
  } = useWorkorderDetailContext();

  const workorderItems = useWorkOrderItems(complement?.id, false);

  const hasPecaAiItems = !!workorderItems.data?.data.some(
    (item) => item.isInPecaAiBasket,
  );

  const hasWOMItems = !!workorderItems.data?.data.some(
    (item) => item.isInWomBasket,
  );

  const [confirmAuthorize, setConfirmAuthorize] = useDisclosure(false);

  const { hasFormChange } = useWorkorderForms();

  const workorderNumber = String(workorder?.number).padStart(6, '0');
  const complementNumber = String(complement?.number).padStart(2, '0');

  const sellingAboveCreditLimit =
    !hasPermissions([
      Authorities.MOVIMENTATION_WORKORDER_MAKE_SALE_ABOVE_CREDIT_LIMIT,
    ]) &&
    (workorder?.customer?.creditLimit || 0) !== 0 &&
    (complement?.totalItems || 0) > (workorder?.customer?.creditLimit || 0);

  return (
    <>
      <Tooltip
        title={
          hasFormChange ? (
            'Por favor, salve as alterações antes de autorizar ordem de serviço.'
          ) : sellingAboveCreditLimit ? (
            <>
              <p>
                O orçamento está ultrapassando o limite de crédito do cliente.
              </p>

              <p>
                Limite de crédito:{' '}
                {formatterPrice(workorder?.customer?.creditLimit || 0)}
              </p>
            </>
          ) : (
            ''
          )
        }
      >
        <Button
          disabled={
            hasFormChange ||
            !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_AUTHORIZE]) ||
            sellingAboveCreditLimit
          }
          block
          type="primary"
          onClick={setConfirmAuthorize.open}
          id="workorder-complement-authorize"
        >
          Autorizar O.S.
        </Button>
      </Tooltip>

      {complement && workorder && (
        <ComplementAuthorizeModal
          open={confirmAuthorize}
          isAlerted={isAlerted}
          setLgpdAlert={setIsAlert}
          onCancel={() => {
            setConfirmAuthorize.close();
          }}
          complementId={complement.id}
          workorderId={workorder.id}
          workorderNumber={`${workorderNumber}/${complementNumber}`}
          customerId={workorder?.customer?.id}
          hasSignature={!!complement.authorizedSignature}
          hasPecaAiBasket={!!complement.pecaAiBasketId && hasPecaAiItems}
          hasWomBasket={!!complement.womBasketId && hasWOMItems}
        />
      )}
    </>
  );
};

export default ComplementAuthorize;
